import { Avatar } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';



const RightSideItem = ({key , proName , proImage}) => {
    return (
        <div className='d-flex mt-2 pl-2 rightItem'>
                <Avatar src={proImage} className="my-1"/>
                <Link to={`/${proName}`}>
                    <h4 className='ml-2 mt-3'> {proName}</h4>
                </Link>
        </div>
    );
};

export default RightSideItem;